import { Component, inject, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FeUtil } from '../../hezky-routes';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-main-layout',
  template: `
    <nz-layout>
      <nz-header>
        <app-header/>
      </nz-header>
      <nz-content>
        <div class="m-3">
          <router-outlet></router-outlet>
        </div>
      </nz-content>
    </nz-layout>
    `
})

export class MainLayoutComponent {
  drawer: boolean = true;
  feUtil = inject(FeUtil);
}
